import { render, staticRenderFns } from "./questionnaireReview.vue?vue&type=template&id=938e6fb4&scoped=true"
import script from "./questionnaireReview.vue?vue&type=script&lang=js"
export * from "./questionnaireReview.vue?vue&type=script&lang=js"
import style0 from "./questionnaireReview.vue?vue&type=style&index=0&id=938e6fb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "938e6fb4",
  null
  
)

export default component.exports